import useMediaQuery from "./mediaQuery";

//TODO: instead of isMobile - use md class prefix
const useIsMobile = useMediaQuery.bind(null, 768);
export default useIsMobile;